const mbtiQuestions = [
  // ─────────────────────────────────
  // EJE E/I — Energía
  // ─────────────────────────────────
  {
    id: 1,
    axis: 'EI',
    question: "Después de un día largo de trabajo, ¿qué te recarga más?",
    options: [
      { value: 'E', text: "Salir con amigos o familia, platicar con gente" },
      { value: 'I', text: "Quedarme solo, leer o ver una serie tranquilo" }
    ]
  },
  {
    id: 2,
    axis: 'EI',
    question: "Cuando tienes una idea nueva, ¿qué haces primero?",
    options: [
      { value: 'E', text: "Se la cuento a alguien para escuchar qué opina" },
      { value: 'I', text: "La pienso bien primero, antes de hablarla" }
    ]
  },
  {
    id: 3,
    axis: 'EI',
    question: "En una fiesta o evento con muchas personas, tú:",
    options: [
      { value: 'E', text: "Me siento cómodo y energético todo el tiempo" },
      { value: 'I', text: "Me canso pronto y necesito momentos para respirar" }
    ]
  },
  {
    id: 4,
    axis: 'EI',
    question: "Si tienes que aprender algo nuevo, prefieres:",
    options: [
      { value: 'E', text: "Hablar con alguien que ya sepa y preguntarle todo" },
      { value: 'I', text: "Buscar yo solo en videos, libros o internet" }
    ]
  },

  // ─────────────────────────────────
  // EJE S/N — Cómo percibes información
  // ─────────────────────────────────
  {
    id: 5,
    axis: 'SN',
    question: "Cuando piensas en tu negocio futuro, te imaginas más:",
    options: [
      { value: 'S', text: "Los pasos concretos de hoy: qué vender, dónde, cómo cobrar" },
      { value: 'N', text: "La visión grande: cambiar vidas, transformar una industria" }
    ]
  },
  {
    id: 6,
    axis: 'SN',
    question: "Te describirías como alguien que:",
    options: [
      { value: 'S', text: "Confía en lo que ya funcionó antes, los hechos comprobados" },
      { value: 'N', text: "Disfruta inventar nuevas formas de hacer las cosas" }
    ]
  },
  {
    id: 7,
    axis: 'SN',
    question: "Cuando lees algo, te enganchan más los textos que:",
    options: [
      { value: 'S', text: "Te enseñan algo práctico que puedes aplicar hoy" },
      { value: 'N', text: "Te hacen pensar en ideas grandes o posibilidades" }
    ]
  },
  {
    id: 8,
    axis: 'SN',
    question: "Si te dieran $10,000 para invertir, tú:",
    options: [
      { value: 'S', text: "Lo meto en algo seguro: ahorro, bienes, algo conocido" },
      { value: 'N', text: "Le entro a algo nuevo: una idea de negocio, una startup" }
    ]
  },

  // ─────────────────────────────────
  // EJE T/F — Cómo decides
  // ─────────────────────────────────
  {
    id: 9,
    axis: 'TF',
    question: "Cuando tomas una decisión importante, te guías más por:",
    options: [
      { value: 'T', text: "La lógica: qué tiene más sentido racional" },
      { value: 'F', text: "Mi corazón: qué se siente correcto para mí y los demás" }
    ]
  },
  {
    id: 10,
    axis: 'TF',
    question: "Si un amigo te pide consejo sobre un problema, tú:",
    options: [
      { value: 'T', text: "Le doy mi análisis objetivo, aunque sea duro" },
      { value: 'F', text: "Primero lo escucho y entiendo cómo se siente" }
    ]
  },
  {
    id: 11,
    axis: 'TF',
    question: "En el trabajo, prefieres a un jefe que:",
    options: [
      { value: 'T', text: "Sea justo y directo, aunque sea estricto" },
      { value: 'F', text: "Sea empático y entienda a su equipo" }
    ]
  },
  {
    id: 12,
    axis: 'TF',
    question: "Cuando criticas el trabajo de alguien, tú:",
    options: [
      { value: 'T', text: "Le digo qué está mal sin maquillar, para que mejore" },
      { value: 'F', text: "Cuido cómo se lo digo para no lastimarlo" }
    ]
  },

  // ─────────────────────────────────
  // EJE J/P — Estructura de vida
  // ─────────────────────────────────
  {
    id: 13,
    axis: 'JP',
    question: "Para tu día a día, prefieres:",
    options: [
      { value: 'J', text: "Tener un plan claro y seguirlo paso a paso" },
      { value: 'P', text: "Ir viendo qué pasa y adaptarme sobre la marcha" }
    ]
  },
  {
    id: 14,
    axis: 'JP',
    question: "Tu espacio de trabajo normalmente está:",
    options: [
      { value: 'J', text: "Ordenado, cada cosa en su lugar" },
      { value: 'P', text: "Funcional pero un poco desordenado, encuentro todo igual" }
    ]
  },
  {
    id: 15,
    axis: 'JP',
    question: "Cuando empiezas un proyecto nuevo, tú:",
    options: [
      { value: 'J', text: "Necesito definir bien el plan antes de empezar" },
      { value: 'P', text: "Empiezo y voy ajustando, no me gusta planear de más" }
    ]
  },
  {
    id: 16,
    axis: 'JP',
    question: "Si tu equipo cambia de planes a última hora, tú:",
    options: [
      { value: 'J', text: "Me estresa, prefiero estabilidad" },
      { value: 'P', text: "Me adapto rápido, hasta lo disfruto" }
    ]
  }
];

export default mbtiQuestions;
